import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatButton } from "@angular/material/button";
import { TranslateModule } from "@ngx-translate/core";
import { NgIf, NgOptimizedImage } from "@angular/common";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { initialInterviewClickIllDoThisLater, routeGatherToProfileOrThankYou } from "../util";
import { TalentHappyPathDataService } from "../../shared/service/talent-happy-path-data-service";
import { InitialInterviewApiService } from "../initial-interview-api.service";
import {ActivatedRoute, Router} from "@angular/router";
import { TalentProfileApiService } from '../../talent-profile/talent-profile-api.service';

@Component({
    imports: [
        MatButton,
        TranslateModule,
        MatProgressSpinnerModule
    ],
    selector: 'app-initial-interview-hang-tight-page',
    templateUrl: './initial-interview-hang-tight-page.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './initial-interview-hang-tight-page.component.scss'
})
export class InitialInterviewHangTightPageComponent implements OnInit {

  jobPostingId: number;
  jobTitle: string;
  orderId: number;
  talent: Talent;
  gatherUUID: string = this.route.snapshot.queryParams['gatheruuid'];
  isGather: boolean = this.gatherUUID != undefined;
  thankYouPath: string = '/thank-you';

  constructor(
    private talentHappyPathDataService: TalentHappyPathDataService,
    private initialInterviewApi: InitialInterviewApiService,
    private router: Router,
    private route: ActivatedRoute,
    private talentProfileApiService: TalentProfileApiService
  ) {}

  ngOnInit() {
    this.talent = this.talentHappyPathDataService.talent;
    this.jobPostingId = this.talentHappyPathDataService.postingId;
    this.jobTitle = this.talentHappyPathDataService.postingInfo.jobTitle;
    this.orderId = this.talentHappyPathDataService.postingInfo.orderId;
  }

  clickIllDoThisLater() {
    if (this.isGather) {
      initialInterviewClickIllDoThisLater('', this.talent, this.jobPostingId, this.orderId, this.jobTitle, this.initialInterviewApi, this.talentHappyPathDataService, this.router, this.gatherUUID);
      routeGatherToProfileOrThankYou(this.talentHappyPathDataService.gather.talentPersonId, this.talentProfileApiService, this.router);
    } else {
      initialInterviewClickIllDoThisLater(this.thankYouPath, this.talent, this.jobPostingId, this.orderId, this.jobTitle, this.initialInterviewApi, this.talentHappyPathDataService, this.router);
    }
  }

}
